import { render, staticRenderFns } from "./AiThingsPage.vue?vue&type=template&id=4cbd1d42&scoped=true&"
import script from "./AiThingsPage.vue?vue&type=script&lang=ts&"
export * from "./AiThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./AiThingsPage.vue?vue&type=style&index=0&id=4cbd1d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd1d42",
  null
  
)

export default component.exports